import type * as React from 'react';
import { CircleCheckIcon } from 'lucide-react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

/* shadcn/ui Toaster without next-themes (the portal has one light theme). Styled with the tokens:
 * popover surface, hairline border, token radius. Success only (design 10): errors stay next to the
 * form or the table they belong to. Mounted once, in AppLayout. */
function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="light"
      position="bottom-right"
      icons={{ success: <CircleCheckIcon className="size-4 text-success" aria-hidden /> }}
      // Sonner paints the action button in --normal-text (ink): a black button no other screen has.
      // Map both buttons onto the Button variants instead (primary = the action, secondary = cancel).
      toastOptions={{
        classNames: {
          actionButton: 'bg-primary! text-primary-foreground! hover:bg-accent-hover!',
          cancelButton: 'bg-secondary! text-secondary-foreground! hover:bg-sunken!',
        },
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
}

export { Toaster };
